<template>
    <div class="main">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />

        <!-- 主體 -->
        <div class="mainContent">
            <b-tabs style="height:100%;" v-model="activeTabIndex">
                <!--
                <b-tab title="訂閱作物" active>
                    訂閱作物內容
                </b-tab>
                -->
                <b-tab title="交易行情">
                    <!-- 條件選單 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="trading_quotes.text" :showMore="false"></PwaTitle>
                        <div class="w3-row">
                            <!-- 種類 -->
                            <div class="w3-col w3-container m4 l4">
                                <p>
                                    <label class="global-descript">{{ trading_quotes.input.type.text }}</label>
                                    <v-select class="global-descript" v-model="trading_quotes.input.type.value" :options="trading_quotes.input.type.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 產品名稱 -->
                            <div class="w3-col w3-container m4 l4">
                                <label class="global-descript">{{ trading_quotes.input.product.text }}</label>
                                <!-- 切換按鈕：訂閱作物/全部 -->
                                <div v-if="subscribedCrops.length > 0 && allCropsList.length > 0" class="w3-margin-bottom">
                                    <b-button-group size="sm">
                                        <b-button :variant="isSubscriptionMode ? 'primary' : 'outline-secondary'" @click="isSubscriptionMode = true; applyProductFilter()">
                                            訂閱作物
                                        </b-button>
                                        <b-button :variant="!isSubscriptionMode ? 'primary' : 'outline-secondary'" @click="isSubscriptionMode = false; applyProductFilter()">
                                            全部
                                        </b-button>
                                    </b-button-group>
                                </div>
                                <!-- 當有產品清單時顯示下拉選單 -->
                                <v-select v-if="trading_quotes.input.product.list.length > 0" class="global-descript" v-model="trading_quotes.input.product.value" :options="trading_quotes.input.product.list" :reduce="(option) => option.value" label="text"></v-select>
                                <!-- 當沒有產品清單時顯示提示 -->
                                <div v-else class="global-descript" style="padding: 0.5rem; color: #999; font-style: italic;">
                                    目前無可用產品
                                </div>
                            </div>
                            <!-- 市場 -->
                            <div class="w3-col w3-container m4 l4">
                                <p>
                                    <label class="global-descript">{{ trading_quotes.input.market.text }}</label>
                                    <v-select class="global-descript" v-model="trading_quotes.input.market.value" :options="trading_quotes.input.market.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                        </div>
                    </b-container>
                    <!-- 價格資訊 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="trading_quotes.trade_day.text" :showMore="false"></PwaTitle>

                        <!-- 交易日期 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.date.text }}</li>
                                <li class="global-descript"> &nbsp; <b>{{ trading_quotes.trade_day.date.value }}</b></li>
                            </ul>
                        </div>
                        <!-- 均價 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.price_avg.text }}</li>
                                <li class="global-descript">NT＄<b>{{ trading_quotes.trade_day.price_avg.value }}</b></li>
                            </ul>
                        </div>
                        <!-- 交易量 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.volume.text }}</li>
                                <li class="global-descript"><b>{{ trading_quotes.trade_day.volume.value }}</b> (公斤)</li>
                            </ul>
                        </div>
                        <!-- 上價 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.price_c.text }}</li>
                                <li class="global-descript">NT＄<b>{{ trading_quotes.trade_day.price_c.value }}</b></li>
                            </ul>
                        </div>
                        <!-- 中價 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.price_m.text }}</li>
                                <li class="global-descript"><b>NT＄</b> {{ trading_quotes.trade_day.price_m.value }}</li>
                            </ul>
                        </div>
                        <!-- 下價 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.price_f.text }}</li>
                                <li class="global-descript"><b>NT＄</b> {{ trading_quotes.trade_day.price_f.value }}</li>
                            </ul>
                        </div>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                    </b-container>
                </b-tab>
                <b-tab title="價量分析">
                    <!-- 條件選單 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="price_volume.text" :showMore="false"></PwaTitle>
                        <div class="w3-row">
                            <!-- 種類 -->
                            <div class="w3-col w3-container m4 l4">
                                <p>
                                    <label class="global-descript">{{ price_volume.input.type.text }}</label>
                                    <v-select class="global-descript" v-model="price_volume.input.type.value" :options="price_volume.input.type.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 產品名稱 -->
                            <div class="w3-col w3-container m4 l4">
                                <label class="global-descript">{{ price_volume.input.product.text }}</label>
                                <!-- 切換按鈕：訂閱作物/全部 -->
                                <div v-if="subscribedCrops.length > 0 && allPriceVolumeCropsList.length > 0" class="w3-margin-bottom">
                                    <b-button-group size="sm">
                                        <b-button :variant="isSubscriptionMode ? 'primary' : 'outline-secondary'" @click="isSubscriptionMode = true; applyPriceVolumeProductFilter()">
                                            訂閱作物
                                        </b-button>
                                        <b-button :variant="!isSubscriptionMode ? 'primary' : 'outline-secondary'" @click="isSubscriptionMode = false; applyPriceVolumeProductFilter()">
                                            全部
                                        </b-button>
                                    </b-button-group>
                                </div>
                                <!-- 當有產品清單時顯示下拉選單 -->
                                <v-select v-if="price_volume.input.product.list.length > 0" class="global-descript" v-model="price_volume.input.product.value" :options="price_volume.input.product.list" :reduce="(option) => option.value" label="text"></v-select>
                                <!-- 當沒有產品清單時顯示提示 -->
                                <div v-else class="global-descript" style="padding: 0.5rem; color: #999; font-style: italic;">
                                    目前無可用產品
                                </div>
                            </div>
                            <!-- 市場 -->
                            <div class="w3-col w3-container m4 l4">
                                <p>
                                    <label class="global-descript">{{ price_volume.input.market.text }}</label>
                                    <v-select class="global-descript" v-model="price_volume.input.market.value" :options="price_volume.input.market.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                        </div>
                    </b-container>
                    <!-- 相關圖表 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="price_volume.week.text" :showMore="false"></PwaTitle>
                        <!-- 簡述 -->
                        <div class="global-descript" v-html="price_volume.week.descript"></div>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                            <div id="chart_trading_quotes_week"></div>
                        </div>
                        <!-- 標題 -->
                        <PwaTitle :textTitle="price_volume.month.text" :showMore="false"></PwaTitle>
                        <!-- 簡述 -->
                        <div class="global-descript" v-html="price_volume.month.descript"></div>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                            <div id="chart_price_volume_month"></div>
                        </div>
                        <!-- 標題 -->
                        <PwaTitle :textTitle="price_volume.year.text" :showMore="false"></PwaTitle>
                        <!-- 簡述 -->
                        <div class="global-descript" v-html="price_volume.year.descript"></div>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                            <div id="chart_price_volume_year"></div>
                        </div>
                    </b-container>
                </b-tab>
                <b-tab title="種植面積">
                    <!-- 條件選單 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="crop_area.text" :showMore="false"></PwaTitle>
                        <div class="w3-row">
                            <!-- 種類 -->
                            <div class="w3-col w3-container m4 l4">
                                <p>
                                    <label class="global-descript">{{ crop_area.input.type.text }}</label>
                                    <v-select class="global-descript" v-model="crop_area.input.type.value" :options="crop_area.input.type.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 產品名稱 -->
                            <div class="w3-col w3-container m4 l4">
                                <label class="global-descript">{{ crop_area.input.product.text }}</label>
                                <!-- 切換按鈕：訂閱作物/全部 -->
                                <div v-if="subscribedCrops.length > 0 && allCropAreaCropsList.length > 0" class="w3-margin-bottom">
                                    <b-button-group size="sm">
                                        <b-button :variant="isSubscriptionMode ? 'primary' : 'outline-secondary'" @click="isSubscriptionMode = true; applyCropAreaProductFilter()">
                                            訂閱作物
                                        </b-button>
                                        <b-button :variant="!isSubscriptionMode ? 'primary' : 'outline-secondary'" @click="isSubscriptionMode = false; applyCropAreaProductFilter()">
                                            全部
                                        </b-button>
                                    </b-button-group>
                                </div>
                                <!-- 當有產品清單時顯示下拉選單 -->
                                <v-select v-if="crop_area.input.product.list.length > 0" class="global-descript" v-model="crop_area.input.product.value" :options="crop_area.input.product.list" :reduce="(option) => option.value" label="text"></v-select>
                                <!-- 當沒有產品清單時顯示提示 -->
                                <div v-else class="global-descript" style="padding: 0.5rem; color: #999; font-style: italic;">
                                    目前無可用產品
                                </div>
                            </div>
                        </div>
                    </b-container>
                    <!-- 相關圖表 -->
                    <b-container fluid class="pb-3">

                        <!-- 標題 -->
                        <PwaTitle :textTitle="crop_area.city.text.replaceAll('{year}',crop_area.city.year)" :showMore="false"></PwaTitle>
                        <!-- 簡述 -->
                        <div class="global-descript" v-html="crop_area.city.descript.replaceAll('{area}',crop_area.city.all_area)"></div>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                            <div id="chart_crop_area_city"></div>
                        </div>

                        <!-- 標題 -->
                        <PwaTitle :textTitle="crop_area.town.text.replaceAll('{year}',crop_area.town.year)" :showMore="false"></PwaTitle>
                        <!-- 簡述 -->
                        <div class="global-descript" v-html="crop_area.town.descript.replaceAll('{area}',crop_area.town.all_area)"></div>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                            <div id="chart_crop_area_town"></div>
                        </div>

                    </b-container>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import PwaTitle from '@/components/pwa/PwaTitle.vue'
export default {
    created() {
        window.vue = this;
        if(!window.checkLogin()){ window.setPage("login");}
    },
    components: {
        Header,
        PwaTitle,
    },
    data(){
        return {
            title: "農業情報站",

            //訂閱作物相關
            subscribedCrops: [], // 使用者訂閱的作物清單
            isSubscriptionMode: false, // 是否為訂閱作物模式（true: 訂閱作物, false: 全部）
            allCropsList: [], // 完整的作物清單（交易行情）
            allPriceVolumeCropsList: [], // 完整的作物清單（價量分析）
            allCropAreaCropsList: [], // 完整的作物清單（種植面積）
            activeTabIndex: 0, // 當前頁籤索引

            //當日交易行情
            trading_quotes:{
                id:"trading_quotes",
                text:"當日交易行情",
                //表單物件
                input:{
                    //種類
                    type:{
                        text:"種類",
                        value:"",
                        placeholder:"請選擇種類",
                        list:[],
                    },
                    //產品名稱
                    product:{
                        text:"產品名稱",
                        value:"",
                        placeholder:"請選擇產品名稱",
                        list:[],
                    },
                    //市場
                    market:{
                        text:"市場",
                        value:"",
                        placeholder:"請選擇市場",
                        list:[],
                    }
                },
                //當日交易行情
                trade_day:{
                    text:"作物近期交易資訊",
                    //是否有結果
                    is_result:false,
                    //交易日期
                    date:{
                        text:"交易日期",
                        value:""
                    },
                    //上價(元/公斤)
                    price_c:{
                        text:"上價",
                        value:0
                    },
                    //中價(元/公斤)
                    price_m:{
                        text:"中價",
                        value:0
                    },
                    //下價(元/公斤)
                    price_f:{
                        text:"下價",
                        value:0
                    },
                    //均價(元/公斤)
                    price_avg:{
                        text:"均價",
                        value:0
                    },
                    //交易量(公斤)
                    volume:{
                        text:"交易量",
                        value:0
                    },
                },
            },
            //價量變化分析
            price_volume:{
                id:"price_volume",
                text:"價量變化分析",
                //表單物件
                input:{
                    //種類
                    type:{
                        text:"種類",
                        value:"",
                        placeholder:"請選擇種類",
                        list:[],
                    },
                    //產品名稱
                    product:{
                        text:"產品名稱",
                        value:"",
                        placeholder:"請選擇產品名稱",
                        list:[],
                    },
                    //市場
                    market:{
                        text:"市場",
                        value:"",
                        placeholder:"請選擇市場",
                        list:[],
                    }
                },
                //一周(近七日)交易行情
                week:{
                    //是否有結果
                    is_result:false,
                    text:"一周交易均價變化圖",
                    descript:"近7日交易均價及成交量。"
                },
                //月交易均價分析圖
                month:{
                    //是否有結果
                    is_result:false,
                    text:"月交易均價分析圖",
                    descript:"近12個月交易均價及成交量。"
                },
                //年交易均價分析圖
                year:{
                    //是否有結果
                    is_result:false,
                    text:"年交易均價分析圖",
                    descript:"近5年交易均價及成交量。"
                },
            },
            //作物種植面積
            crop_area:{
                id:"crop_area",
                text:"作物種植面積",
                //表單物件
                input:{
                    //種類
                    type:{
                        text:"種類",
                        value:"",
                        placeholder:"請選擇種類",
                        list:[],
                    },
                    //產品名稱
                    product:{
                        text:"產品名稱",
                        value:"",
                        placeholder:"請選擇產品名稱",
                        list:[],
                    },
                },
                //全台-縣市面積
                city:{
                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",
                    //全國總面積
                    all_area:"",
                    text:"{year}年各縣市種植面積",
                    descript:"全國種植總面積共{area}公頃。",
                },
                //指定縣市-鄉鎮市區面積
                town:{
                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",
                    //縣市總面積
                    all_area:"",
                    text:"{year}年雲林縣鄉鎮種植面積",
                    descript:"雲林縣種植總面積共{area}公頃。",
                }
            },

            //api 取得農業情報站預設值(網頁剛載入時，預設選取)
            apiGetIntelligenceAgri: (data) => this.userRequest.post("/API/Default/GetIntelligenceAgri", data),

            //api 取得種類(該選項相對應的資訊)
            apiGetTradeAgriTypeInfo: (data) => this.userRequest.post("/API/Default/GetTradeAgriTypeInfo", data),

            //api 取得產品名稱(該選項相對應的資訊)
            apiGetTradeAgriProductInfo: (data) => this.userRequest.post("/API/Default/GetTradeAgriProductInfo", data),

            //api 取得市場名稱(該選項相對應的資訊)
            apiGetTradeAgriMarketInfo: (data) => this.userRequest.post("/API/Default/GetTradeAgriMarketInfo", data),

        }
    },
    watch: {

        //監聽頁籤切換
        activeTabIndex: function(newVal) {
            // 當頁籤切換時，重新檢查並應用對應頁籤的過濾邏輯
            this.$nextTick(() => {
                if (newVal === 0) {
                    // 交易行情頁籤
                    if (this.allCropsList.length > 0) {
                        // 檢查是否有訂閱作物在當前清單中
                        const hasSubscribedCrops = this.subscribedCrops.length > 0 &&
                            this.allCropsList.some(crop => this.subscribedCrops.includes(crop.anaCId));

                        // 如果有訂閱作物，優先使用訂閱模式
                        if (hasSubscribedCrops) {
                            this.isSubscriptionMode = true;
                        }

                        this.applyProductFilter();
                    }
                } else if (newVal === 1) {
                    // 價量分析頁籤
                    if (this.allPriceVolumeCropsList.length > 0) {
                        // 檢查是否有訂閱作物在當前清單中
                        const hasSubscribedCrops = this.subscribedCrops.length > 0 &&
                            this.allPriceVolumeCropsList.some(crop => this.subscribedCrops.includes(crop.anaCId));

                        // 如果有訂閱作物，優先使用訂閱模式
                        if (hasSubscribedCrops) {
                            this.isSubscriptionMode = true;
                        }

                        this.applyPriceVolumeProductFilter();
                    }
                } else if (newVal === 2) {
                    // 種植面積頁籤
                    if (this.allCropAreaCropsList.length > 0) {
                        // 檢查是否有訂閱作物在當前清單中
                        const hasSubscribedCrops = this.subscribedCrops.length > 0 &&
                            this.allCropAreaCropsList.some(crop => this.subscribedCrops.includes(crop.anaCId));

                        // 如果有訂閱作物，優先使用訂閱模式
                        if (hasSubscribedCrops) {
                            this.isSubscriptionMode = true;
                        }

                        this.applyCropAreaProductFilter();
                    }
                }
            });
        },

        //當日交易行情-種類
        "trading_quotes.input.type.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.trading_quotes.trade_day.is_result = false;
                this.getTradingQuotesTypeInfo();
            }
        },
        //當日交易行情-產品名稱
        "trading_quotes.input.product.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.trading_quotes.trade_day.is_result = false;
                this.getTradingQuotesProductInfo();
            }
        },
        //當日交易行情-市場
        "trading_quotes.input.market.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.trading_quotes.trade_day.is_result = false;
                this.getTradingQuotesMarketInfo();
            }
        },

        //價量變化分析-種類
        "price_volume.input.type.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.price_volume.week.is_result = false;
                this.price_volume.month.is_result = false;
                this.price_volume.year.is_result = false;
                this.getPriceVolumeTypeInfo();
            }
        },
        //價量變化分析-產品名稱
        "price_volume.input.product.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.price_volume.week.is_result = false;
                this.price_volume.month.is_result = false;
                this.price_volume.year.is_result = false;
                this.getPriceVolumeProductInfo();
            }
        },
        //價量變化分析-市場
        "price_volume.input.market.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.price_volume.week.is_result = false;
                this.price_volume.month.is_result = false;
                this.price_volume.year.is_result = false;
                this.getPriceVolumeMarketInfo();
            }
        },

        //作物種植面積-種類
        "crop_area.input.type.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.crop_area.city.is_result = false;
                this.crop_area.town.is_result = false;
                this.getCropAreaTypeInfo();
            }
        },
        //作物種植面積-產品名稱
        "crop_area.input.product.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.crop_area.city.is_result = false;
                this.crop_area.town.is_result = false;
                this.getAreaTypeProductInfo();
            }
        },
    },
    mounted(){
        // 先取得訂閱作物清單，再載入預設資料
        this.getSubscribedCrops();
        this.getIntelligenceAgri();
    },
    destroyed() {},
    methods: {

        //取得使用者訂閱的作物清單
        getSubscribedCrops: function() {
            this.FunctionToken(this.getSubscribedCropsCallback, {});
        },

        //取得使用者訂閱的作物清單回調
        getSubscribedCropsCallback: function(data) {
            this.userRequest.get('/API/CropSubscription/account-items', {
                params: {
                    TokenID: data.TokenID,
                    Token: data.Token
                }
            })
            .then((res) => {
                console.log("訂閱作物清單", res.data);
                if (Array.isArray(res.data)) {
                    // 將訂閱的作物 ID 存儲起來
                    this.subscribedCrops = res.data.map(item => item.AnalysisCropId);

                    // 如果有訂閱作物，預設使用訂閱模式
                    if (this.subscribedCrops.length > 0) {
                        this.isSubscriptionMode = true;
                        // 如果已經載入了作物清單，重新應用過濾
                        if (this.allCropsList.length > 0) {
                            this.applyProductFilter();
                        }
                        if (this.allPriceVolumeCropsList.length > 0) {
                            this.applyPriceVolumeProductFilter();
                        }
                        if (this.allCropAreaCropsList.length > 0) {
                            this.applyCropAreaProductFilter();
                        }
                    }
                }
            })
            .catch((err) => {
                console.log("取得訂閱作物清單失敗", err);
                // 失敗時使用全部模式
                this.subscribedCrops = [];
                this.isSubscriptionMode = false;
            });
        },

        //應用產品過濾（根據訂閱/全部模式）- 交易行情
        applyProductFilter: function() {
            if (this.allCropsList.length === 0) {
                return;
            }

            if (this.isSubscriptionMode && this.subscribedCrops.length > 0) {
                // 訂閱模式：只顯示訂閱的作物（使用 id 即 ANA_C_ID 來比對）
                this.trading_quotes.input.product.list = this.allCropsList.filter(crop =>
                    this.subscribedCrops.includes(crop.anaCId)
                );

                // 如果訂閱模式下沒有符合的作物，自動切換到全部模式
                if (this.trading_quotes.input.product.list.length === 0) {
                    console.log("訂閱模式下無符合的作物，自動切換到全部模式");
                    this.isSubscriptionMode = false;
                    this.trading_quotes.input.product.list = [...this.allCropsList];
                }
            } else {
                // 全部模式：顯示所有作物
                this.trading_quotes.input.product.list = [...this.allCropsList];
            }

            // 如果當前選中的產品不在新的列表中，選擇第一個
            const currentValue = this.trading_quotes.input.product.value;
            const isCurrentInList = this.trading_quotes.input.product.list.some(item => item.value === currentValue);

            if (!isCurrentInList && this.trading_quotes.input.product.list.length > 0) {
                this.trading_quotes.input.product.value = this.trading_quotes.input.product.list[0].value;
            }
        },

        //應用產品過濾（根據訂閱/全部模式）- 價量分析
        applyPriceVolumeProductFilter: function() {
            if (this.allPriceVolumeCropsList.length === 0) {
                return;
            }

            if (this.isSubscriptionMode && this.subscribedCrops.length > 0) {
                // 訂閱模式：只顯示訂閱的作物（使用 id 即 ANA_C_ID 來比對）
                this.price_volume.input.product.list = this.allPriceVolumeCropsList.filter(crop =>
                    this.subscribedCrops.includes(crop.anaCId)
                );

                // 如果訂閱模式下沒有符合的作物，自動切換到全部模式
                if (this.price_volume.input.product.list.length === 0) {
                    console.log("價量分析：訂閱模式下無符合的作物，自動切換到全部模式");
                    this.isSubscriptionMode = false;
                    this.price_volume.input.product.list = [...this.allPriceVolumeCropsList];
                }
            } else {
                // 全部模式：顯示所有作物
                this.price_volume.input.product.list = [...this.allPriceVolumeCropsList];
            }

            // 如果當前選中的產品不在新的列表中，選擇第一個
            const currentValue = this.price_volume.input.product.value;
            const isCurrentInList = this.price_volume.input.product.list.some(item => item.value === currentValue);

            if (!isCurrentInList && this.price_volume.input.product.list.length > 0) {
                this.price_volume.input.product.value = this.price_volume.input.product.list[0].value;
            }
        },

        //應用產品過濾（根據訂閱/全部模式）- 種植面積
        applyCropAreaProductFilter: function() {
            if (this.allCropAreaCropsList.length === 0) {
                return;
            }

            if (this.isSubscriptionMode && this.subscribedCrops.length > 0) {
                // 訂閱模式：只顯示訂閱的作物（使用 id 即 ANA_C_ID 來比對）
                this.crop_area.input.product.list = this.allCropAreaCropsList.filter(crop =>
                    this.subscribedCrops.includes(crop.anaCId)
                );

                // 如果訂閱模式下沒有符合的作物，自動切換到全部模式
                if (this.crop_area.input.product.list.length === 0) {
                    console.log("種植面積：訂閱模式下無符合的作物，自動切換到全部模式");
                    this.isSubscriptionMode = false;
                    this.crop_area.input.product.list = [...this.allCropAreaCropsList];
                }
            } else {
                // 全部模式：顯示所有作物
                this.crop_area.input.product.list = [...this.allCropAreaCropsList];
            }

            // 如果當前選中的產品不在新的列表中，選擇第一個
            const currentValue = this.crop_area.input.product.value;
            const isCurrentInList = this.crop_area.input.product.list.some(item => item.value === currentValue);

            if (!isCurrentInList && this.crop_area.input.product.list.length > 0) {
                this.crop_area.input.product.value = this.crop_area.input.product.list[0].value;
            }
        },

        //啟用遮罩
        enableDefaultLoad:function()
        {
            this.enableMask();
            this.default_load = true;
        },
        //取消遮罩
        disableDefaultLoad:function()
        {
            //暫時先設定延遲，否則watch會重複觸發
            const _this = this;
            window.ThreadTool.Delay(function(){

                _this.disableMask();
                _this.default_load = false;

            },this.delay_ms_api);
        },

        //設定當日交易行情-種類
        setTradingQuotesInputType:function(TradeCropType)
        {
            //當日交易行情-種類
            this.trading_quotes.input.type.value = "";
            this.trading_quotes.input.type.list = [];
            if(TradeCropType.length > 0)
            {
                for(var i=0 ; i<TradeCropType.length ; i++)
                {
                    //當日交易行情-種類
                    this.trading_quotes.input.type.list.push({value:TradeCropType[i].E_TYPE,text:TradeCropType[i].E_TYPE});
                }
            }
        },
        //設定價量變化分析-種類
        setPriceVolumeInputType:function(TradeCropType)
        {
            //價量變化分析-種類
            this.price_volume.input.type.value = "";
            this.price_volume.input.type.list = [];
            if(TradeCropType.length > 0)
            {
                for(var i=0 ; i<TradeCropType.length ; i++)
                {
                    //價量變化分析-種類
                    this.price_volume.input.type.list.push({value:TradeCropType[i].E_TYPE,text:TradeCropType[i].E_TYPE});
                }
            }
        },
        //設定作物種植面積-種類
        setCropAreaInputType:function(TradeCropType)
        {
            //作物種植面積-種類
            this.crop_area.input.type.value = "";
            this.crop_area.input.type.list = [];
            if(TradeCropType.length > 0)
            {
                for(var i=0 ; i<TradeCropType.length ; i++)
                {
                    //作物種植面積-種類
                    this.crop_area.input.type.list.push({value:TradeCropType[i].E_TYPE,text:TradeCropType[i].E_TYPE});
                }
            }
        },

        //設定當日交易行情-產品名稱
        setTradingQuotesInputProduct:function(TradeCropName)
        {
            //當日交易行情-產品名稱
            this.trading_quotes.input.product.value = "";
            this.trading_quotes.input.product.list = [];
            this.allCropsList = []; // 清空完整清單

            if(TradeCropName.length > 0)
            {
                for(var i=0 ; i<TradeCropName.length ; i++)
                {
                    //保存到完整清單，value 使用 CROP_CODE，但保留 id 用於過濾
                    this.allCropsList.push({
                        value:TradeCropName[i].CROP_CODE,
                        text:TradeCropName[i].CROP,
                        anaCId:TradeCropName[i].ANA_C_ID
                    });
                }

                // 應用過濾（根據訂閱/全部模式）
                this.applyProductFilter();

                // 使用 $nextTick 確保 list 更新後再設定 value
                this.$nextTick(() => {
                    if(this.trading_quotes.input.product.list.length > 0) {
                        this.trading_quotes.input.product.value = this.trading_quotes.input.product.list[0].value;
                    }
                });
            }
        },
        //設定價量變化分析-產品名稱
        setPriceVolumeInputProduct:function(TradeCropName)
        {
            //價量變化分析-產品名稱
            this.price_volume.input.product.value = "";
            this.price_volume.input.product.list = [];
            this.allPriceVolumeCropsList = []; // 清空完整清單

            if(TradeCropName.length > 0)
            {
                for(var i=0 ; i<TradeCropName.length ; i++)
                {
                    //保存到完整清單，value 使用 CROP_CODE，但保留 id 用於過濾
                    this.allPriceVolumeCropsList.push({
                        value:TradeCropName[i].CROP_CODE,
                        text:TradeCropName[i].CROP,
                        anaCId:TradeCropName[i].ANA_C_ID
                    });
                }

                // 應用過濾（根據訂閱/全部模式）
                this.applyPriceVolumeProductFilter();

                // 使用 $nextTick 確保 list 更新後再設定 value
                this.$nextTick(() => {
                    if(this.price_volume.input.product.list.length > 0) {
                        this.price_volume.input.product.value = this.price_volume.input.product.list[0].value;
                    }
                });
            }
        },
        //設定作物種植面積-產品名稱
        setCropAreaInputProduct:function(TradeCropName)
        {
            //作物種植面積-產品名稱
            this.crop_area.input.product.value = "";
            this.crop_area.input.product.list = [];
            this.allCropAreaCropsList = []; // 清空完整清單

            if(TradeCropName.length > 0)
            {
                for(var i=0 ; i<TradeCropName.length ; i++)
                {
                    //保存到完整清單，value 使用 CROP_CODE，但保留 id 用於過濾
                    this.allCropAreaCropsList.push({
                        value:TradeCropName[i].CROP_CODE,
                        text:TradeCropName[i].CROP,
                        anaCId:TradeCropName[i].ANA_C_ID
                    });
                }

                // 應用過濾（根據訂閱/全部模式）
                this.applyCropAreaProductFilter();

                // 使用 $nextTick 確保 list 更新後再設定 value
                this.$nextTick(() => {
                    if(this.crop_area.input.product.list.length > 0) {
                        this.crop_area.input.product.value = this.crop_area.input.product.list[0].value;
                    }
                });
            }
        },

        //設定當日交易行情-市場
        setTradingQuotesInputMarket:function(TradeCropMarket)
        {
            //當日交易行情-市場
            this.trading_quotes.input.market.value = "";
            this.trading_quotes.input.market.list = [];
            if(TradeCropMarket.length > 0)
            {
                for(var i=0 ; i<TradeCropMarket.length ; i++)
                {
                    //當日交易行情-市場
                    this.trading_quotes.input.market.list.push({value:TradeCropMarket[i].MARKET,text:TradeCropMarket[i].MARKET});
                }
                this.trading_quotes.input.market.value = TradeCropMarket[0].MARKET;
            }
        },
        //設定價量變化分析-市場
        setPriceVolumeInputMarket:function(TradeCropMarket)
        {
            //價量變化分析-市場
            this.price_volume.input.market.value = "";
            this.price_volume.input.market.list = [];
            if(TradeCropMarket.length > 0)
            {
                for(var i=0 ; i<TradeCropMarket.length ; i++)
                {
                    //價量變化分析-市場
                    this.price_volume.input.market.list.push({value:TradeCropMarket[i].MARKET,text:TradeCropMarket[i].MARKET});
                }
                this.price_volume.input.market.value = TradeCropMarket[0].MARKET;
            }
        },

        //設定當日交易行情-作物近期交易資訊
        setTradeCropDay:function(TradeCropDay)
        {
            if(TradeCropDay.length > 0)
            {
                var item = TradeCropDay[0];
                this.trading_quotes.trade_day.date.value = item.T_DATE;
                this.trading_quotes.trade_day.price_c.value = item.PRICE_C;
                this.trading_quotes.trade_day.price_m.value = item.PRICE_M;
                this.trading_quotes.trade_day.price_f.value = item.PRICE_F;
                this.trading_quotes.trade_day.price_avg.value = item.PRICE_AVG;
                this.trading_quotes.trade_day.volume.value = item.VOLUME;
                this.trading_quotes.trade_day.is_result = true;
            }
        },
        //設定當日交易行情-一周交易均價變化圖
        setTradeCropWeek:function(TradeCropWeek)
        {
            if(TradeCropWeek.length > 0)
            {
                var column_week = [];
                var line_week = [];
                for(var i=0 ; i<TradeCropWeek.length ; i++)
                {
                    column_week.push({
                        //交易日期
                        x:TradeCropWeek[i].T_DATE,
                        //交易量
                        y:this.getRounded(TradeCropWeek[i].VOLUME/1000)
                    });

                    line_week.push({
                        //交易日期
                        x:TradeCropWeek[i].T_DATE,
                        //均價
                        y:this.getRounded(TradeCropWeek[i].PRICE_AVG)
                    });
                }

                this.price_volume.week.is_result = true;

                window.ThreadTool.Delay(function(){

                    window.setChartIntelligenceTradingQuotesWeek("#chart_trading_quotes_week",{
                        column:column_week,
                        line:line_week
                    });

                },this.delay_ms_chart);
            }
        },

        //設定價量變化分析-月交易均價分析圖
        setTradeCropMonth:function(TradeCropMonth)
        {
            if(TradeCropMonth.length > 0)
            {
                var column_month = [];
                var line_month = [];
                for(var i=0 ; i<TradeCropMonth.length ; i++)
                {
                    column_month.push({
                        //交易日期
                        x:TradeCropMonth[i].T_YEAR_MONTH,
                        //交易量
                        y:this.getRounded(TradeCropMonth[i].VOLUME)
                    });

                    line_month.push({
                        //交易日期
                        x:TradeCropMonth[i].T_YEAR_MONTH,
                        //均價
                        y:this.getRounded(TradeCropMonth[i].PRICE_AVG)
                    });
                }

                this.price_volume.month.is_result = true;
                window.ThreadTool.Delay(function(){

                    window.setChartIntelligencePriceVolumeMonth("#chart_price_volume_month",{
                        column:column_month,
                        line:line_month
                    });

                },this.delay_ms_chart);
            }
        },

        //設定價量變化分析-年交易均價分析圖
        setTradeCropYear:function(TradeCropYear)
        {
            if(TradeCropYear.length > 0)
            {
                var column_year = [];
                var line_year = [];
                for(var i=0 ; i<TradeCropYear.length ; i++)
                {
                    column_year.push({
                        //交易日期
                        x:TradeCropYear[i].T_YEAR,
                        //交易量
                        y:this.getRounded(TradeCropYear[i].VOLUME)
                    });

                    line_year.push({
                        //交易日期
                        x:TradeCropYear[i].T_YEAR,
                        //均價
                        y:this.getRounded(TradeCropYear[i].PRICE_AVG)
                    });
                }

                this.price_volume.year.is_result = true;

                window.ThreadTool.Delay(function(){

                    window.setChartIntelligencePriceVolumeYear("#chart_price_volume_year",{
                        column:column_year,
                        line:line_year
                    });

                },this.delay_ms_chart);

            }
        },

        //設定作物種植面積-Xxx年各縣市種植面積
        setAgriSurveyArea:function(AgriSurveyArea)
        {
            if(AgriSurveyArea.length > 0)
            {
                var data_area = [];
                this.crop_area.city.all_area = 0;
                for(var i=0 ; i<AgriSurveyArea.length ; i++)
                {
                    data_area.push({
                        //縣市
                        x:AgriSurveyArea[i].CITY,
                        //種植面積
                        y:this.getRounded(AgriSurveyArea[i].AREA_P)
                    });

                    this.crop_area.city.all_area += Number(this.getRounded(AgriSurveyArea[i].AREA_P));
                }

                console.log(this.crop_area.city.all_area);
                this.crop_area.city.all_area = this.crop_area.city.all_area.toFixed(2);

                this.crop_area.city.year = AgriSurveyArea[0].A_YEAR,
                this.crop_area.city.is_result = true;

                window.ThreadTool.Delay(function(){

                    window.setChartIntelligenceCropAreaCity("#chart_crop_area_city",{
                        data:data_area
                    });

                },this.delay_ms_chart);
            }
        },

        //設定作物種植面積-Xxx年雲林縣鄉鎮種植面積
        setAgriSurveyAreaCity:function(AgriSurveyAreaCity)
        {
            if(AgriSurveyAreaCity.length > 0)
            {
                var data_area_town = [];
                this.crop_area.town.all_area = 0;
                for(var i=0; i<AgriSurveyAreaCity.length ; i++)
                {
                    data_area_town.push({
                        //鄉鎮市區
                        x:AgriSurveyAreaCity[i].TOWN,
                        //種植面積
                        y:this.getRounded(AgriSurveyAreaCity[i].AREA_P)
                    });

                    this.crop_area.town.all_area += Number(this.getRounded(AgriSurveyAreaCity[i].AREA_P));
                }

                this.crop_area.town.all_area = this.crop_area.town.all_area.toFixed(2);
                this.crop_area.town.all_area = parseFloat(this.crop_area.town.all_area);
                console.log(this.crop_area.town.all_area);
                this.crop_area.town.all_area = this.crop_area.town.all_area.toFixed(2);

                this.crop_area.town.year = AgriSurveyAreaCity[0].A_YEAR,
                this.crop_area.town.is_result = true;

                window.ThreadTool.Delay(function(){

                    window.setChartIntelligenceCropAreaTown("#chart_crop_area_town",{
                        data:data_area_town,
                    });

                },this.delay_ms_chart);
            }
        },

        //取得農業情報站預設值
        getIntelligenceAgri:function()
        {
            this.enableDefaultLoad();
            this.apiGetIntelligenceAgri({

                CITY:"雲林縣",
                E_TYPE:"蔬菜",
                CROP_CODE:"SG2",
                MARKET:"西螺鎮",
            })
            .then((res)=>{

                //以下先設定為null，因為會發生換頁時，他非null執行updateOptions會報錯，所以統一初始時，幫他設定Null
                //因為Vue是用元件切換，所以在換頁時，default_chart 並不會重載，只有整個重新整理才會重載，所以換頁時時常會出現錯誤
                window.ChartIntelligenceTradingQuotesWeek = null;
                window.ChartIntelligencePriceVolumeMonth = null;
                window.ChartIntelligencePriceVolumeYear = null;
                window.ChartIntelligenceCropAreaCity = null;
                window.ChartIntelligenceCropAreaTown = null;

                const data = JSON.parse(res.data);

                console.log(data);

                //當日交易行情-種類
                //價量變化分析-種類
                //作物種植面積-種類
                const TradeCropType = data.TradeCropType;

                //當日交易行情-產品名稱
                //價量變化分析-產品名稱
                //作物種植面積-產品名稱
                const TradeCropName = data.TradeCropName;

                //當日交易行情-市場
                //價量變化分析-市場
                const TradeCropMarket = data.TradeCropMarket;

                //當日交易行情-作物近期交易資訊
                const TradeCropDay = data.TradeCropDay;
                //當日交易行情-一周交易均價變化圖
                const TradeCropWeek = data.TradeCropWeek;

                //價量變化分析-月交易均價分析圖
                const TradeCropMonth = data.TradeCropMonth;
                //價量變化分析-年交易均價分析圖
                const TradeCropYear = data.TradeCropYear;

                //作物種植面積-Xxx年各縣市種植面積
                const AgriSurveyArea = data.AgriSurveyArea;
                //作物種植面積-Xxx年雲林縣鄉鎮種植面積
                const AgriSurveyAreaCity = data.AgriSurveyAreaCity;

                //設定當日交易行情-種類
                this.setTradingQuotesInputType(TradeCropType);
                this.trading_quotes.input.type.value = "蔬菜";
                //設定價量變化分析-種類
                this.setPriceVolumeInputType(TradeCropType);
                this.price_volume.input.type.value = "蔬菜";
                //設定作物種植面積-種類
                this.setCropAreaInputType(TradeCropType);
                this.crop_area.input.type.value = "蔬菜";

                //設定當日交易行情-產品名稱
                this.setTradingQuotesInputProduct(TradeCropName);
                this.trading_quotes.input.product.value = "SG2";
                //設定價量變化分析-產品名稱
                this.setPriceVolumeInputProduct(TradeCropName);
                this.price_volume.input.product.value = "SG2";
                //設定作物種植面積-產品名稱
                this.setCropAreaInputProduct(TradeCropName);
                this.crop_area.input.product.value = "SG2";

                //設定當日交易行情-市場
                this.setTradingQuotesInputMarket(TradeCropMarket);
                this.trading_quotes.input.market.value = "西螺鎮";
                //設定價量變化分析-市場
                this.setPriceVolumeInputMarket(TradeCropMarket);
                this.price_volume.input.market.value = "西螺鎮";

                //設定當日交易行情-作物近期交易資訊
                this.setTradeCropDay(TradeCropDay);
                //設定當日交易行情-一周交易均價變化圖
                this.setTradeCropWeek(TradeCropWeek);

                //設定價量變化分析-月交易均價分析圖
                this.setTradeCropMonth(TradeCropMonth);
                //設定價量變化分析-年交易均價分析圖
                this.setTradeCropYear(TradeCropYear);

                //設定作物種植面積-Xxx年各縣市種植面積
                this.setAgriSurveyArea(AgriSurveyArea);
                //設定作物種植面積-Xxx年雲林縣鄉鎮種植面積
                this.setAgriSurveyAreaCity(AgriSurveyAreaCity);

                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        },

        //取得當日交易行情-種類切換時，要呈現的資訊
        getTradingQuotesTypeInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeAgriTypeInfo({

                E_TYPE:this.trading_quotes.input.type.value
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //當日交易行情-產品名稱
                const TradeCropName = data.TradeCropName;
                //當日交易行情-市場
                const TradeCropMarket = data.TradeCropMarket;
                //當日交易行情-作物近期交易資訊
                const TradeCropDay = data.TradeCropDay;

                //設定當日交易行情-產品名稱
                this.setTradingQuotesInputProduct(TradeCropName);
                //設定當日交易行情-市場
                this.setTradingQuotesInputMarket(TradeCropMarket);

                //設定當日交易行情-作物近期交易資訊
                this.setTradeCropDay(TradeCropDay);

                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });

        },
        //取得價量變化分析-種類切換時，要呈現的資訊
        getPriceVolumeTypeInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeAgriTypeInfo({

                E_TYPE:this.price_volume.input.type.value
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //價量變化分析-產品名稱
                const TradeCropName = data.TradeCropName;
                //價量變化分析-市場
                const TradeCropMarket = data.TradeCropMarket;
                //價量變化分析-一周交易均價變化圖
                const TradeCropWeek = data.TradeCropWeek;
                //價量變化分析-月交易均價分析圖
                const TradeCropMonth = data.TradeCropMonth;
                //價量變化分析-年交易均價分析圖
                const TradeCropYear = data.TradeCropYear;

                console.log(data);

                //設定價量變化分析-產品名稱
                this.setPriceVolumeInputProduct(TradeCropName);
                //設定價量變化分析-市場
                this.setPriceVolumeInputMarket(TradeCropMarket);

                //設定價量變化分析-一周交易均價變化圖
                this.setTradeCropWeek(TradeCropWeek);
                //設定價量變化分析-月交易均價分析圖
                this.setTradeCropMonth(TradeCropMonth);
                //設定價量變化分析-年交易均價分析圖
                this.setTradeCropYear(TradeCropYear);

                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        },
        //取得作物種植面積-種類切換時，要呈現的資訊
        getCropAreaTypeInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeAgriTypeInfo({

                E_TYPE:this.crop_area.input.type.value,
                CITY:"雲林縣"
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //作物種植面積-產品名稱
                const TradeCropName = data.TradeCropName;
                //作物種植面積-Xxx年各縣市種植面積
                const AgriSurveyArea = data.AgriSurveyArea;
                //作物種植面積-Xxx年雲林縣鄉鎮種植面積
                const AgriSurveyAreaCity = data.AgriSurveyAreaCity;

                //設定作物種植面積-產品名稱
                this.setCropAreaInputProduct(TradeCropName);

                //設定作物種植面積-Xxx年各縣市種植面積
                this.setAgriSurveyArea(AgriSurveyArea);
                //設定作物種植面積-Xxx年雲林縣鄉鎮種植面積
                this.setAgriSurveyAreaCity(AgriSurveyAreaCity);

                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        },

        //取得當日交易行情-產品名稱切換時，要呈現的資訊
        getTradingQuotesProductInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeAgriProductInfo({

                CROP_CODE:this.trading_quotes.input.product.value
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //當日交易行情-市場
                const TradeCropMarket = data.TradeCropMarket;
                //當日交易行情-作物近期交易資訊
                const TradeCropDay = data.TradeCropDay;

                //設定當日交易行情-市場
                this.setTradingQuotesInputMarket(TradeCropMarket);

                //設定當日交易行情-作物近期交易資訊
                this.setTradeCropDay(TradeCropDay);

                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });

        },
        //取得價量變化分析-產品名稱切換時，要呈現的資訊
        getPriceVolumeProductInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeAgriProductInfo({

                CROP_CODE:this.price_volume.input.product.value
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //價量變化分析-市場
                const TradeCropMarket = data.TradeCropMarket;
                //價量變化分析-一周交易均價變化圖
                const TradeCropWeek = data.TradeCropWeek;
                //價量變化分析-月交易均價分析圖
                const TradeCropMonth = data.TradeCropMonth;
                //價量變化分析-年交易均價分析圖
                const TradeCropYear = data.TradeCropYear;

                //設定價量變化分析-市場
                this.setPriceVolumeInputMarket(TradeCropMarket);

                //設定價量變化分析-一周交易均價變化圖
                this.setTradeCropWeek(TradeCropWeek);
                //設定價量變化分析-月交易均價分析圖
                this.setTradeCropMonth(TradeCropMonth);
                //設定價量變化分析-年交易均價分析圖
                this.setTradeCropYear(TradeCropYear);

                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });

        },
        //取得作物種植面積-產品名稱切換時，要呈現的資訊
        getAreaTypeProductInfo:function()
        {
            this.addUserActionLog({

                TokenID:sessionStorage.getItem("TokenID"),
                WebPage:"農業情報站",
                WebAction:"提交",
                ActionMemo:"作物種植面積",
                RequestData:JSON.stringify({

                    CROP_CODE:this.crop_area.input.product.value,
                    CITY:"雲林縣",
                })
            });

            this.enableDefaultLoad();
            this.apiGetTradeAgriProductInfo({

                CROP_CODE:this.crop_area.input.product.value,
                CITY:"雲林縣",
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //作物種植面積-Xxx年各縣市種植面積
                const AgriSurveyArea = data.AgriSurveyArea;
                //作物種植面積-Xxx年雲林縣鄉鎮種植面積
                const AgriSurveyAreaCity = data.AgriSurveyAreaCity;

                //設定作物種植面積-Xxx年各縣市種植面積
                this.setAgriSurveyArea(AgriSurveyArea);
                //設定作物種植面積-Xxx年雲林縣鄉鎮種植面積
                this.setAgriSurveyAreaCity(AgriSurveyAreaCity);

                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });

        },

        //取得當日交易行情-市場切換時，要呈現的資訊
        getTradingQuotesMarketInfo:function()
        {
            this.addUserActionLog({

                TokenID:sessionStorage.getItem("TokenID"),
                WebPage:"農業情報站",
                WebAction:"提交",
                ActionMemo:"當日交易行情",
                RequestData:JSON.stringify({

                    CROP_CODE:this.trading_quotes.input.product.value,
                    MARKET:this.trading_quotes.input.market.value,
                })
            });

            this.enableDefaultLoad();
            this.apiGetTradeAgriMarketInfo({
                CROP_CODE:this.trading_quotes.input.product.value,
                MARKET:this.trading_quotes.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //當日交易行情-作物近期交易資訊
                const TradeCropDay = data.TradeCropDay;

                //設定當日交易行情-作物近期交易資訊
                this.setTradeCropDay(TradeCropDay);

                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });

        },
        //取得價量變化分析-市場切換時，要呈現的資訊
        getPriceVolumeMarketInfo:function()
        {
            this.addUserActionLog({

                TokenID:sessionStorage.getItem("TokenID"),
                WebPage:"農業情報站",
                WebAction:"提交",
                ActionMemo:"價量變化分析",
                RequestData:JSON.stringify({

                    CROP_CODE:this.trading_quotes.input.product.value,
                    MARKET:this.trading_quotes.input.market.value,
                })
            });

            this.enableDefaultLoad();
            this.apiGetTradeAgriMarketInfo({
                CROP_CODE:this.price_volume.input.product.value,
                MARKET:this.price_volume.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                console.log(data);

                //價量變化分析-一周交易均價變化圖
                const TradeCropWeek = data.TradeCropWeek;
                //價量變化分析-月交易均價分析圖
                const TradeCropMonth = data.TradeCropMonth;
                //價量變化分析-年交易均價分析圖
                const TradeCropYear = data.TradeCropYear;

                //設定價量變化分析-一周交易均價變化圖
                this.setTradeCropWeek(TradeCropWeek);
                //設定價量變化分析-月交易均價分析圖
                this.setTradeCropMonth(TradeCropMonth);
                //設定價量變化分析-年交易均價分析圖
                this.setTradeCropYear(TradeCropYear);

                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });

        },

    }
}
</script>
